import React from "react";
import LocalizedStrings from 'react-localization';
import { connect } from "react-redux";
import { Grid } from "@mui/material";
import { localisedText } from "../../lib/localisation.es6";
import GenerateReports from './components/GenerateReports.js'
import HeaderRibbonInc from "../../shared-ui/HeaderRibbonInc/index.js";
import { getReportTemplateRequest } from "../ReportsConfigs/Redux/actions.js";
import { generateReportRequest, resetGenerateReport } from "./Redux/actions.js";
import { getPartner } from "../../lib/access.es6";
class Reports extends React.Component {

  constructor(props) {
    const localizedStrings = new LocalizedStrings(localisedText);
    super(props);
    this.state = {
      labels: localizedStrings,
    }
  }

  componentWillMount() {
    this.updateLanguage();
    this.props.dispatch(getReportTemplateRequest());
  }

  componentDidUpdate() {
    this.updateLanguage();
  }

  updateLanguage() {
    const language = this.props.globalData.language;
    let resetLanguage = false;
    if (!language) {
      resetLanguage = true;
    }
    const labels = this.state.labels;
    if (resetLanguage || labels.getLanguage() !== language) {
      labels.setLanguage(language);
      this.setState({});
    }
  }

  generateReport(payload) {
    // const type = document.getElementById('type').value;
    // const payload = {
    //   type,
    // };
    this.props.dispatch(generateReportRequest(payload));
    console.log("payload", payload)
  }
  resetGenerateReport(){
    this.props.dispatch(resetGenerateReport());
  }

  // Check if current partner is AccessBank
  isAccessBankPartner() {
    try {
      const partner = getPartner();
      return partner && partner.guid === 'accessbank';
    } catch (e) {
      return false;
    }
  }


  render() {

    if (this.props.ReportsTemplateData.reportTemplates) {

      return (
        <>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12}>
              <HeaderRibbonInc title={this.state.labels.generateReport} />
              {/* Data availability notice - show for all partners */}
              {(
                <div style={{
                  background: "#f8f9fa",
                  border: "1px solid #dee2e6",
                  borderRadius: "8px",
                  padding: "16px",
                  marginTop: "20px",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px"
                }}>
                  <div style={{
                    background: "#17a2b8",
                    borderRadius: "50%",
                    width: "24px",
                    height: "24px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontSize: "14px",
                    fontWeight: "bold"
                  }}>
                    i
                  </div>
                  <div>
                    <h4 style={{ margin: "0 0 4px 0", fontSize: "14px", fontWeight: "600", color: "#495057" }}>
                      Data Availability Notice
                    </h4>
                    <p style={{ margin: "0", fontSize: "13px", color: "#6c757d", lineHeight: "1.4" }}>
                      Reports are generated from our data warehouse, which is refreshed daily at 3:00 AM. 
                      Data is available up to the previous day only. For real-time updates, please check back after the daily refresh.
                    </p>
                  </div>
                </div>
              )}
              <section style={{
                background: "#FFFFFF",
                borderRadius: "8px",
                height: "auto",
                marginTop: "20px",
                padding: "30px"
              }}>
                <GenerateReports
                  templates={this.props.ReportsTemplateData.reportTemplates}
                  loader={this.props.ReportsTemplateData.getReportTemplatesloader}
                  generateReport={this.generateReport.bind(this)}

                  showGenerateReportProgressAlert={
                    this.props.GenerateReportData.getReportloader
                  }
                  showGenerateReportSuccessAlert={
                    this.props.GenerateReportData.getReportSuccess
                  }
                  showGenerateReportErrorAlert={
                    !!this.props.GenerateReportData.getReportError
                  }
                  generateReportError={
                    this.props.GenerateReportData.getReportError
                  }
                  resetGenerateReport= {this.resetGenerateReport.bind(this)}
                  reportBlob={this.props.GenerateReportData.reportBlob}
                  labels={this.state.labels}
                />


              </section>
            </Grid>
          </Grid>
        </>
      )

    } else {
      return "No  reports found"
    }



  }

}

export default connect((state) => ({
  ReportsTemplateData: state.ReportsTemplateData,
  GenerateReportData: state.GenerateReportData,
  globalData: state.global,
}))(Reports);